import { DateFilterOptionType } from '../models';

export interface DateFilterOptionLabel {
  id: DateFilterOptionType;
  label: string;
}

export const dateFilterOptions: DateFilterOptionLabel[] = [
  {
    id: DateFilterOptionType.Last7Days,
    label: 'Last 7 days',
  },
  {
    id: DateFilterOptionType.Last30Days,
    label: 'Last 30 days',
  },
  {
    id: DateFilterOptionType.Last90Days,
    label: 'Last 90 days',
  },
];
